document.addEventListener('DOMContentLoaded', function() {
var swiper3 = new Swiper(".job-main-slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    watchOverflow: true,
    pagination: {
        el: ".job-slider-pagination",
        type: "fraction",
      },
      navigation: {
        nextEl: ".job-slider-next",
        prevEl: ".job-slider-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
  });
});